<template>
  <div class="work-process-list">
    <CCard>

      <CCardHeader v-if="!orderId">
        <CButton color="primary"
                 class="float-right"
                 @click="showAddModal = true; selectedWorkProcess = null;">
          <CIcon name="cil-plus" size="sm"/>
          Dodaj delovni proces
        </CButton>
      </CCardHeader>

      <CCardBody>
        <Loading :active="loading"/>

        <CDataTable
            :items="workProcesses"
            :fields="fields"
            hover
            striped
        >
          <template #vehicle_model="{ item }">
            <td>
              <strong>{{ item.vehicle_model ? item.vehicle_model.name : '-' }}</strong>
              ({{
                item.vehicle_model && item.vehicle_model.vehicle_brand ? item.vehicle_model.vehicle_brand.title : '-'
              }})
            </td>
          </template>

          <template #task_total_count="{ item }">
            <td>
              <strong> <span v-if="orderId" title="Dokončano"
                             class="text-success">{{ item.task_total_completed }} / </span> <span class="text-muted"
                                                                                                  title="Vse naloge">{{
                  item.task_total_count
                }} </span></strong>
            </td>
          </template>

          <template #task_total_time="{ item }">
            <td>
              <strong>{{ item.task_total_time }}h</strong>
            </td>
          </template>


          <template #created_at="{ item }">
            <td>{{ formatDate(item.created_at) }}</td>
          </template>

          <template #details="{ item }">
            <CCollapse :show="!!item._showDetails">
              <CCardBody>
                <Loading :active="item._loadingTasks"/>
                <template v-if="!item._loadingTasks">
                  <div v-if="item.tasks && item.tasks.length > 0">
                    <CDataTable
                        :items="item.tasks"
                        :fields="taskFields"
                        small
                        hover
                        striped
                    >
                      <template #started_at="{ item: task }">
                        <td>{{ formatDate(task.started_at) }}</td>
                      </template>

                      <template #completed_at="{ item: task }">
                        <td>{{ formatDate(task.completed_at) }}</td>
                      </template>

                      <template #default_role="{ item: task }">
                        <td>{{ task.default_role ? task.default_role.name : '-' }}</td>
                      </template>

                      <template #worker="{ item: task }">
                        <td>{{ task.is_worker_free ? "Da" : "Ne" }}</td>
                      </template>

                      <template #default_user="{ item: task }">
                        <td>{{ task.default_user ? task.default_user.name : '-' }}</td>
                      </template>

                      <template #actions="{ item: task }">
                        <td class="text-right">
                          <div class="d-flex gap-1">
                            <CButton
                                color="warning"
                                size="sm"
                                class="mx-1"
                                @click="editTask(item, task)"
                            >
                              <CIcon name="cil-pencil" size="sm"/>
                            </CButton>
                            <CButton
                                color="secondary"
                                size="sm"
                                class="mx-1"
                                title="Podvoji"
                                @click="handleDuplicateTask(item, task)"
                            >

                              <CIcon name="cil-copy" size="sm"/>
                            </CButton>
                            <CButton
                                color="danger"
                                size="sm"
                                class="mx-1"
                                @click="handleDeleteTask(item, task)"
                            >

                              <CIcon name="cil-trash" size="sm"/>
                            </CButton>
                            <span v-if="orderId" class="border-start border-1 border-secondary d-block"
                                  style="width: 1px"></span>
                            <div class="form-group" v-if="orderId">
                              <CInputCheckbox
                                  class="form-check-input mx-1"
                                  v-if="orderId"
                                  :checked="task.completed"
                                  width="50"
                                  height="50"
                                  @change="handleToggleTaskCompleted(item, task)"
                                  title="Preklopi dokončanje naloge"
                              />
                            </div>

                          </div>
                        </td>
                      </template>
                    </CDataTable>
                  </div>
                  <div v-else class="text-center py-3">
                    <p class="text-muted mb-0">Ni razpoložljivih nalog.</p>
                  </div>
                </template>
                <CButton
                    color="primary"
                    size="sm"
                    class="mt-2 pull-right"
                    @click="addNewTask(item)"
                >
                  <CIcon name="cil-plus"></CIcon>
                  Dodaj novo nalogo
                </CButton>
              </CCardBody>
            </CCollapse>
          </template>

          <template #actions="{ item }">
            <td class="text-right">
              <div class="d-flex gap-1">
                <CButton
                    color="primary"
                    size="sm"
                    class="mx-1"
                    @click="toggleDetails(item)"
                >
                  <CIcon
                      name="cil-list"
                      size="sm"
                  />
                </CButton>
                <CButton
                    color="warning"
                    size="sm"
                    class="mx-1"
                    @click="editWorkProcess(item)"
                >
                  <CIcon name="cil-pencil" size="sm"/>
                </CButton>
                <CButton
                    color="secondary"
                    size="sm"
                    class="mx-1"
                    title="Podvoji"
                    @click="handleDuplicateWorkProcess(item, task)"
                >
                  <CIcon name="cil-copy" size="sm"/>
                </CButton>
                <CButton
                    color="danger"
                    size="sm"
                    class="mx-1"
                    v-if="!orderId"
                    @click="confirmDelete(item)"
                >
                  <CIcon name="cil-trash" size="sm"/>
                </CButton>
                <span v-if="orderId" class="border-start border-1 border-secondary d-block" style="width: 1px"></span>
                <CButton
                    v-if="orderId"
                    color="warning"
                    size="sm"
                    class="mx-1"
                    title="Odstrani"
                    @click="detachWorkProcess(item)"
                >
                  <CIcon name="cil-ban" size="sm"/>
                </CButton>
              </div>
            </td>
          </template>
        </CDataTable>

        <CPagination
            :active-page="currentPage"
            :pages="totalPages"
            @update:activePage="pageChange"
        />
      </CCardBody>
    </CCard>

    <!-- Add new process -->
    <CModal :show.sync="showAddModal" title="Delovni proces" size="lg">
      <WorkProcessForm
          :workProcess="selectedWorkProcess"
          :showAddModal="showAddModal"
          @submit="handleWorkProcessSubmit"
          @cancel="showAddModal = false"
      />
      <template #footer>
        <CButton type="submit" color="primary" form="workProcessForm">Shrani</CButton>
        <CButton color="secondary" @click="showAddModal = false; selectedWorkProcess = null; ">Prekliči</CButton>
      </template>
    </CModal>

    <!-- Add new task -->
    <CModal :show.sync="showTaskModal" :title="selectedTask ? 'Uredi nalogo' : 'Dodaj novo nalogo'" size="lg">
      <TaskForm
          :task="selectedTask"
          :workProcessId="selectedWorkProcess ? selectedWorkProcess.id : undefined"
          :orderId="orderId"
          :showTaskModal="showTaskModal"
          :form-type="orderId ? 'extended' : 'normal'"
          @submit="handleTaskSubmit"
          @cancel="showTaskModal = false"
      />
      <template #footer>
        <CButton type="submit" color="primary" form="taskForm">Shrani</CButton>
        <CButton color="secondary" @click="showTaskModal = false; selectedTask = null; ">Prekliči</CButton>
      </template>
    </CModal>
    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>


<script>
import {mapState, mapActions} from 'vuex'
import WorkProcessForm from '../components/WorkProcessForm'
import TaskForm from '../components/TaskForm'
import TaskList from '../components/TaskList'
import {format} from 'date-fns'
import Loading from 'vue-loading-overlay'
import {CIcon} from '@coreui/icons-vue'
import PermissionCheck from '@/tools/permission-check';

export default {
  name: 'WorkProcessList',
  props: {
    orderId: {
      type: [String, Number],
      default: null,
    },
    addWorkProcessButtonClicked: {
      type: Number,
      default: 0,
    },
    attachWorkProcessButtonClicked: {
      type: Number,
      default: 0,
    },
    selectedWorkProcessToAttach: {
      type: Number,
      default: null,
    },
    isOrderPage: {
      type: Boolean,
      default: false,
    }
  },
  components: {
    Loading,
    WorkProcessForm,
    TaskForm,
    TaskList,
    CIcon
  },

  data() {
    return {
      fields: [
        {key: 'name', label: 'Delovni process'},
        {key: 'vehicle_model', label: 'Model'},
        {key: 'task_total_count', label: 'St. nalog'},
        {key: 'task_total_time', label: 'Celotni potrebni čas'},
        {key: 'created_at', label: 'Datum kreiranja'},
        {key: 'actions', label: 'Akcije'}
      ],
      taskFields: [
        {key: 'name', label: 'Opravilo'},
        {key: 'description', label: 'Opis'},
        {key: 'time', label: 'Dolžina'},
        {key: 'worker', label: 'Delavec prost?'},
        {key: 'default_role', label: 'Rola'},
        {key: 'default_user', label: 'Uporabnik'},
        {key: 'started_at', label: 'Začelo ob'},
        {key: 'completed_at', label: 'Končano ob'},
        {key: 'actions', label: 'Akcije'}
      ],
      showAddModal: false,
      showTaskModal: false,
      selectedWorkProcess: null,
      selectedTask: null,
      roles: {
        'licar': 'Licacar',
        'klepar': 'Klepar'
      },
      permissionCheck: PermissionCheck,
    }
  },

  computed: {
    ...mapState('workProcesses', {
      workProcesses: state => state.workProcesses,
      workProcessesAvailable: state => state.workProcessesAvailable,
      totalPagesAvailable: state => state.totalPagesAvailable,
      currentPage: state => state.currentPage,
      totalPages: state => state.totalPages,
      loading: state => state.loading
    })
  },

  watch: {
    addWorkProcessButtonClicked: {
      handler() {
        this.showAddModal = true;
        this.selectedWorkProcess = null;
      }
    },
    attachWorkProcessButtonClicked: {
      handler() {
        this.attachWorkProcess();
      }
    },
  },

  methods: {
    ...mapActions('workProcesses', [
      'fetchWorkProcesses',
      'deleteWorkProcess',
      'createWorkProcess',
      'updateWorkProcess',
      'duplicateWorkProcess',
      'duplicateTask',
      'fetchTasks',
      'createTask',
      'updateTask',
      'deleteTask',
      'toggleTaskCompleted',
      'attachWorkProcessToOrder',   // New action for attaching
      'detachWorkProcessFromOrder', // New action for detaching
      'setCurrentPage',
    ]),

    formatDate(date) {
      return date ? format(new Date(date), 'dd/MM/yyyy HH:mm') : '-'
    },

    getRoleName(roleId) {
      return this.roles[roleId] || roleId
    },

    pageChange(page) {
      this.setCurrentPage(page);
      this.fetchWorkProcesses({page, perPage: 10, orderId: this.orderId, isOrderPage: this.isOrderPage})
          .catch((error) => {

            this.$refs.toastr.e('Error', 'Napaka pri iskanju processa!')
          })
    },

    toggleDetails(item) {
      this.selectedWorkProcess = item._showDetails ? item : null;
      this.$store.commit('workProcesses/SET_ITEM_DETAILS', {
        itemId: item.id,
        value: !item._showDetails
      })

      if (!item._showDetails && (!item.tasks || !item.tasks.length)) {
        this.$store.commit('workProcesses/SET_ITEM_LOADING', {
          itemId: item.id,
          value: true
        })

        this.fetchTasks(item.id)
            .then(tasks => {
              this.$store.commit('workProcesses/SET_ITEM_TASKS', {
                itemId: item.id,
                tasks
              })
            })
            .finally(() => {
              this.$store.commit('workProcesses/SET_ITEM_LOADING', {
                itemId: item.id,
                value: false
              })
            })
      }
    },

    editWorkProcess(workProcess) {
      this.selectedWorkProcess = {...workProcess}
      this.showAddModal = true
    },

    confirmDelete(workProcess) {
      if (confirm('Ste prepričani, da želite izbrisati proces?')) {
        this.deleteWorkProcess(workProcess.id)
            .then(() => {
              this.$refs.toastr.s('Success', 'Izbris uspešen!')
              return this.fetchWorkProcesses({page: this.currentPage})
            })
            .catch(() => {
              this.$refs.toastr.e('Error', 'Napaka pri brisanju processa')
            })
      }
    },

    handleDuplicateWorkProcess(workProcess) {
      return this.$store.dispatch('workProcesses/duplicateWorkProcess', workProcess.id)
          .then(() => {
            this.$refs.toastr.s('Success', 'Process podvojen!')
            return this.fetchWorkProcesses({page: this.currentPage, orderId: this.orderId})
          })
          .catch((error) => {
            this.$refs.toastr.e('Error', 'Napaka pri podvajanju procesa')
            throw error
          })
    },
    handleDuplicateTask(workProcess, task) {
      return this.$store.dispatch('workProcesses/duplicateTask',{ workProcessId:  workProcess.id, taskId: task.id})
          .then(() => {
            this.$refs.toastr.s('Success', 'Naloga podvojena')
            return this.fetchTasks(workProcess.id)
          }).then(tasks => {
            this.$store.commit('workProcesses/SET_ITEM_TASKS', {
              itemId: workProcess.id,
              tasks
            })
          })
          .catch((error) => {
            this.$refs.toastr.e('Error', 'Napaka pri podvajanju!')
            throw error
          })
    },

    handleWorkProcessSubmit(workProcess) {
      console.log(workProcess);
      const action = workProcess.id
          ? this.updateWorkProcess({
            id: workProcess.id,
            data: workProcess,
            orderId: this.orderId
          })
          : this.createWorkProcess({workProcess: workProcess, orderId: this.orderId})

      action
          .then(() => {
            this.$refs.toastr.s('Success', `Proces ${workProcess.id ? 'posodobljen' : 'kreiran'}!`)
            this.showAddModal = false
            this.selectedWorkProcess = null
            return this.fetchWorkProcesses({
              page: this.currentPage,
              orderId: this.orderId,
              isOrderPage: this.isOrderPage
            })
          })
          .catch(() => {
            this.$refs.toastr.e('Error', 'Napaka pri shranjuevaju')
          })
    },

    addNewTask(workProcess) {
      this.selectedWorkProcess = workProcess
      this.selectedTask = this.orderId ? { autoassign: true } : null
      this.showTaskModal = true
    },

    editTask(workProcess, task) {
      this.selectedWorkProcess = workProcess
      this.selectedTask = {...task}
      this.showTaskModal = true
    },

    handleDeleteTask(workProcess, task) {
      if (confirm('Želite izbrisati opravilo?')) {
        this.deleteTask({
          workProcessId: workProcess.id,
          taskId: task.id
        })
            .then(() => {
              this.$refs.toastr.s('Success', 'Opravilo izbrisano!')
              return this.fetchTasks(workProcess.id)
            })
            .then(tasks => {
              this.$store.commit('workProcesses/SET_ITEM_TASKS', {
                itemId: workProcess.id,
                tasks
              })
            })
            .catch(() => {
              this.$refs.toastr.e('Error', 'Napaka pri brisanju')
            })
      }
    },

    handleTaskSubmit(task) {
      const action = task.id
          ? this.updateTask({
            workProcessId: this.selectedWorkProcess.id,
            taskId: task.id,
            data: task
          })
          : this.createTask({
            workProcessId: this.selectedWorkProcess.id,
            task
          })

      action
          .then(() => {
            this.$refs.toastr.s('Success', `Opravilo ${task.id ? 'posodoboljeno' : 'kreirano'}!`)
            this.showTaskModal = false
            this.selectedTask = null
            return this.fetchTasks(this.selectedWorkProcess.id)
          })
          .then(tasks => {
            this.$store.commit('workProcesses/SET_ITEM_TASKS', {
              itemId: this.selectedWorkProcess.id,
              tasks
            })
          })
          .catch(error => {
            this.$refs.toastr.e('Error', error.response?.data?.error || 'Napaka pri shranjevanju')
          })
    },
    handleFetchAvailableWorkProcesses() {
      console.log("handleFetchAvailableWorkProcesses");
      this.fetchWorkProcesses({paginate: false, isOrderPage: this.isOrderPage, fetchAvailable: true})
          .catch((error) => {
            console.error(error)
            this.$refs.toastr.e('Error', 'Failed to fetch available work processes');
          })
          .finally(() => {
            this.$emit('workProcessesFetched', this.workProcessesAvailable);
          });
    },
    attachWorkProcess() {
      if (!this.selectedWorkProcessToAttach) return;

      this.attachWorkProcessToOrder({
          orderId: this.orderId,
          workProcessId: this.selectedWorkProcessToAttach,
        })
        .then(() => {
          this.$refs.toastr.s('Success', 'Delovni process uspešno dodan na delovni nalog!');
          this.refetchWorkProcesses();
        })
        .catch((error) => {
          this.$refs.toastr.e('Error', error.response.data.error || 'Failed to attach work process');
        })
        .finally(() => {
          this.$emit('workProcessAttached');
        });
    },

    handleToggleTaskCompleted(workProcess, task) {

      this.toggleTaskCompleted({
        taskId: task.id,
        workProcessId: workProcess.id,
      })
          .then(() => {
            this.$refs.toastr.s('Success', 'Opravilo posodobljeno');
            this.refetchWorkProcesses().then(() => {
              if (this.selectedWorkProcess) {
                this.toggleDetails(this.selectedWorkProcess)
              }
            })
          })
          .catch(() => {
            this.$refs.toastr.e('Error', 'Failed to toggle the task completion');
          });
    },

    // Detach a work process from the order
    detachWorkProcess(workProcess) {
      this.detachWorkProcessFromOrder({
        orderId: this.orderId,
        workProcessId: workProcess.id,
      })
          .then(() => {
            this.$refs.toastr.s('Success', 'Delovno opravilo odstranjeno!');
            this.refetchWorkProcesses();
          })
          .catch(() => {
            this.$refs.toastr.e('Error', 'Failed to detach work process');
          });
    },

    // Refetch the work processes after changes
    refetchWorkProcesses() {
      const promise = this.fetchWorkProcesses({
        page: this.currentPage, orderId: this.orderId,
        isOrderPage: !!this.orderId
      });
      if (this.orderId) this.handleFetchAvailableWorkProcesses();

      return promise;
    },
  },

  created() {
    this.fetchWorkProcesses({
      page: 1,
      orderId: this.orderId,
      isOrderPage: this.isOrderPage
    });
    if (this.isOrderPage) {
      this.handleFetchAvailableWorkProcesses();
    }
  }
}
</script>

<style scoped>
.work-process-list .mx-1 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.work-process-list .gap-2 {
  gap: 0.5rem;
}
</style>
